import { FeatureToggleClientService } from 'feature-toggle-client';
const HubspotAction = 'hubspot-analytics-integration';
export default class HubspotActionFeatures {
    static hubspotActionApplicationEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(HubspotAction);
    }
}
